import { QueryParams } from '@/model';
import apiClient from '../api/apiClient';
import { buildApiUrl } from '../utils';
import {
  GetPollsAccountResponse,
  GetPollsByUUIDResponse,
  GetPollsResponse,
  PostPollsResponse,
  PutPollsResponse,
} from '../response/polls';

export class PollService {
  static getPolls(params?: QueryParams) {
    return apiClient.get<GetPollsResponse>(buildApiUrl('/api/v1/interactive-area/polls'), params);
  }

  static putPolls(id: string, data: any) {
    const url = buildApiUrl('/api/v1/interactive-area/polls/:id', { id });
    return apiClient.updateWithFile<PutPollsResponse>(url, data);
  }

  static getPollsAccount(id: string) {
    const url = buildApiUrl('/api/v1/interactive-area/polls/:id/account', { id });
    return apiClient.get<GetPollsAccountResponse>(url, undefined);
  }

  static getPollsByUUID(id: string) {
    const url = buildApiUrl('/api/v1/interactive-area/polls/:id', { id });
    return apiClient.get<GetPollsByUUIDResponse>(url, undefined);
  }

  static postPolls(data: any) {
    return apiClient.createWithFile<PostPollsResponse>(buildApiUrl('/api/v1/interactive-area/polls'), data);
  }

  static putPollsInteractive(id: string, data: any) {
    const url = buildApiUrl('/api/v1/interactive-area/polls/:id/interactivity', { id });
    return apiClient.update<void>(url, data);
  }

  static deletePolls(id: string) {
    const url = buildApiUrl('/api/v1/interactive-area/polls/:id', { id });
    return apiClient.delete<void>(url);
  }
}
